import { useAuth0 } from "@auth0/auth0-react"
import { Button, Label } from "@inkblot-therapy/squid"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

export const SubmitSuccess = () => {
  const { t } = useTranslation()

  const navigate = useNavigate()
  const { logout } = useAuth0()

  return (
    <div className="flex flex-col h-[100vh] mt-28 items-center max-w-2xl mx-auto">
      <div className="pb-[56px] flex flex-col">
        <div>
          <Label
            strong={false}
            className="text-[color:var(--core-color-slate-90)] [font-family:var(--alias-font-display-xl-font-family)] [font-size:var(--alias-font-display-xl-font-size)]"
          >
            {t("client.uploadCsv.successReferralSubmissionHeader")}
          </Label>
        </div>
        <Label
          strong={false}
          className="text-[color:var(--alias-color-text-weaker)] [font-family:var(--alias-font-display-md-font-family)] [font-size:var(--alias-font-display-md-font-size)]"
        >
          {t("client.uploadCsv.successReferralSubmissionSubHeader")}
        </Label>
      </div>
      <div className="w-full flex gap-4 justify-end">
        <Button
          onClick={() => logout({ returnTo: window.location.origin })}
          variant="outlined"
        >
          {t("client.buttons.logout")}
        </Button>
        <Button onClick={() => navigate("/ontario/upload")} variant="primary">
          {t("client.buttons.submitAnother")}
        </Button>
      </div>
    </div>
  )
}
